import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {  
    fetchNotifications, 
    updateNotificationStatus, 
    markAllNotificationsAsRead
} from '../services/userNotification';
import { toast } from 'react-toastify';

/**
 * Hook to fetch notifications
 * Optionally can pass filters: userId and viewed
 */
export const useFetchNotifications = (filters = {}) => {
  return useQuery({
    queryKey: ['notifications', filters],
    queryFn: fetchNotifications,
    cacheTime: 5 * 60 * 1000,
    staleTime: 0,
  });
};

/**
 * Hook to update one notification's read/unread status
 */
export const useUpdateNotificationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, viewed }) => updateNotificationStatus(id, viewed),
    onSuccess: () => {
      toast.success('Notification status updated successfully.');
      queryClient.invalidateQueries(['notifications']); 
    },
    onError: () => {
      toast.error('Error updating notification status.');
    },
  });
};

/**
 * Hook to mark all notifications as read for a user
 */
export const useMarkAllNotificationsAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId) => markAllNotificationsAsRead(userId),
    onSuccess: () => {
      toast.success('All notifications marked as read.');
      queryClient.invalidateQueries(['notifications']); 
    },
    onError: () => {
      toast.error('Error marking notifications as read.');
    },
  });
};
